import {
  IconButton,
  withStyles,
  StyledComponentProps,
  Icon,
} from "@material-ui/core";
import toast from "react-hot-toast";
import React from "react";

const snackbarCloseButtonStyles = () => ({
  root: {
    color: "white",
  },
});

interface ISnackbarCloseButtonProps extends StyledComponentProps {
  id: string | undefined;
}

const SnackbarCloseButtonComponent: React.FC<ISnackbarCloseButtonProps> = ({
  id,
  classes = {},
}) => {
  return (
    <IconButton
      size='small'
      classes={{ root: classes.root }}
      onClick={() => toast.dismiss(id)}>
      <Icon>close</Icon>
    </IconButton>
  );
};

const SnackbarCloseButton = withStyles(snackbarCloseButtonStyles)(
  SnackbarCloseButtonComponent
);

export { SnackbarCloseButton };
